import type { FC, ReactElement } from 'react';

import { useRedirectToLobbyCallbackConnected } from '../../../hooks/useRedirectToLobbyCallbackConnected';
import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { getWindowObject } from '../../../utils/window';
import { Button, ButtonVariant } from '../../controls/button/Button';

import { BlockingModalContent } from './BlockingModalContent';

export const SessionBalanceErrorConnected: FC = (): ReactElement => {
  const redirectToLobby = useRedirectToLobbyCallbackConnected();
  const windowObject = getWindowObject();

  const action = [
    <Button
      key="EXIT"
      tk="EXIT"
      variant={ButtonVariant.MAIN}
      onClick={() => {
        redirectToLobby();
      }}
    />,
    <Button
      key="OK"
      tk="OK"
      variant={ButtonVariant.ACCENT}
      onClick={() => {
        windowObject.location.reload();
      }}
    />,
  ];

  return (
    <BlockingModalContent actions={action}>
      <L10nText tk="ERROR_COMMUNICATION" />
    </BlockingModalContent>
  );
};
